import { Link } from '@mui/joy';
import { t } from 'i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Value } from 'core/types';
import { formatDate } from 'core/utils';

export const getLinkValue = (value: Value, url: string) => {
  if (!url) {
    return value;
  }

  return (
    <Link component={RouterLink} to={url} target="_blank" fontSize={14} fontWeight={600}>
      {value}
    </Link>
  );
};

export const getValidValue = (validSince?: string, validUntil?: string) => {
  const validSinceFormatted = formatDate(validSince);
  const validUntilFormatted = formatDate(validUntil);

  if (!validSince && !validUntil) {
    return t('labelNoSpecificDates');
  }

  if (!validUntil) {
    return t('labelSinceDate', { date: validSinceFormatted });
  }

  if (!validSince) {
    return t('labelUntilDate', { date: validUntilFormatted });
  }

  return `${validSinceFormatted} - ${validUntilFormatted}`;
};
